import request from './request';

export const getTopicsWithBoxesByCohort = (cohortId) =>
    request({
        url: `/topics/boxes?cohortId=${cohortId}`,
        method: 'get'
    })
